module.exports = __webpack_public_path__ + "static/media/clinician-stroke-risk-factors-preview@3x.df928772.png";